import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { useRouter } from "next/router";
import { design } from "@/services/design";
import { DEBUGGER } from "@/helper/helper";
import { useCustomLogo } from "@/states/design.state";
import useUpdateQrConfig from "@/components/page-modules/builder/__shared/hooks/request/useUpdateQrConfig";
import { QrTypeProps } from "@/components/page-modules/builder/__shared/data/builder-qr.type";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import { useConfig } from "@/states/common.state";

type Prop = {
  selectedType: QrTypeProps;
  setLogo?: (params: any) => void;
  setError?: (params: any) => void;
};

const useLogoUpdate = ({ setLogo, setError, selectedType }: Prop) => {
  const queryClient = useQueryClient();
  const router = useRouter();

  const { setCustomLogo } = useCustomLogo();
  const { payload, files } = useConfig();
  const { updateQrConfig } = useUpdateQrConfig(selectedType);
  const { mutateHomeQr } = useGenerateHomeQr(false);

  const {
    mutate: mutateLogoUpdate,
    isLoading: isLoadingLogoUpdate,
    data: customLogo,
    isError: isUploadError,
  } = useMutation((params: any) => design.postUpdateLogo(params), {
    onSuccess: (data) => {
      updateQrConfig({
        optionlogo: data.data.uuid,
        logo_size: 75,
      });
      setCustomLogo({ logo: data.data });

      if (!router.pathname.includes("/dashboard")) {
        mutateHomeQr({
          params: { ...payload, files },
          configParams: { optionlogo: data.data.uuid },
        });
      }

      if (setLogo) {
        setLogo({
          upload_logo: data.data.uuid,
          scale_logo: 75,
        });
      }
      queryClient.invalidateQueries("USER_LOGO");
    },
    onError: (error: AxiosError) => {
      DEBUGGER("Error updating logo => ", error);
      if (setError) {
        setError(error.response?.data?.message || "");
      }
    },
  });

  return {
    mutateLogoUpdate,
    isLoadingLogoUpdate,
    customLogo,
    isUploadError,
  };
};

export default useLogoUpdate;
